import { render, staticRenderFns } from "@/style-guide/partials/tooltip/tooltip.pug?vue&type=template&id=3970d014&lang=pug&external"
import script from "./tooltip.vue?vue&type=script&lang=ts"
export * from "./tooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports